import script from "./newsInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./newsInfo.vue?vue&type=script&setup=true&lang=js"

import "./newsInfo.vue?vue&type=style&index=0&id=05444afb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05444afb"]])

export default __exports__